import { IAddPaymentMethod } from 'src/types'

export const viewOptionTypes = {
  public: 'public',
  private: 'private'
}

export const ServiceOptionDisplay = {
  ON_DEMAND: 'On Demand',
  SCHEDULED: 'Scheduled'
}

export const NotificationOptionsDisplay = {
  ON_DEMAND: 'On Demand Trip Reminder',
  SCHEDULED: 'Scheduled Trip Reminder',
  WILL_CALL: 'Will Call Trip Reminder'
}

export const DEFAULT_PAYMENT_METHODS: IAddPaymentMethod[] = [
  {
    serviceId: '',
    paymentName: 'Cash'
  },
  {
    serviceId: '',
    paymentName: 'Wallet'
  }
]

export const MembershipTypes = Object.freeze({
  PERMANENT: 'permanent',
  TEMPORARY_LIMITED_PERIOD: 'temporary_limited_period',
  TEMPORARY_LIMITED_RIDES_AMOUNT: 'temporary_limited_rides_amount',
  TEMPORARY_RECURRING_PERIOD: 'temporary_recurring_period'
})

const DISCOUNT_TYPE = {
  PERCENTAGE: 'percentage',
  FIXED: 'fixed'
} as const

export const discountTypeOptions = Object.freeze([
  {
    value: DISCOUNT_TYPE.PERCENTAGE,
    label: 'Percentage'
  },
  {
    value: DISCOUNT_TYPE.FIXED,
    label: 'Fixed'
  }
])



// WEBPACK FOOTER //
// ./src/constants/service.ts